import { deepEquals } from 'app/infrastructure/js';
import { FilterValues } from '../types';

export const getUpdatedFilters = (filters: FilterValues, previousFilters: FilterValues): FilterValues => {
  return Object.keys(filters).reduce((result, key) => {
    return !deepEquals(filters[key], previousFilters[key])
      ? {
        ...result,
        [key]: filters[key]
      }
      : result;
  }, {} as FilterValues);
};
